export default __webpack_public_path__ + "static/media/step1.e15fd1f2.png";